export enum PersistenceScope {
  None,
  LocalStorage,
  SessionStorage,
  Backend
}
